export default function copy(str) {
  return new Promise((resolve, reject) => {
    if (document.execCommand) {
      let textArea = document.createElement("textarea");
      textArea.value = str;
      textArea.style.position = "absolute";
      textArea.style.opacity = 0;
      textArea.style.left = "-100%";
      textArea.style.top = "-100%";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      resolve()
    } else {
      let data = new DataTransfer();
      data.items.add("text/plain", str);
      navigator.clipboard.write(data)
      resolve()
    }
    reject()
  })
}



// WEBPACK FOOTER //
// ./src/utils/copy.js